import React from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import SignImg from '../assets/sign.json';
import { useNavigate, useLocation } from 'react-router-dom';
import useFormStore from "../state/useFormStore";
import Firma from '../components/Firma';
import withAuthAndData from '../components/withAuthAndData';
import Spacer from '../components/Spacer';

const Wrapper = styled.div`
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 36px;
  padding-bottom: 100px;
`;

const MainText = styled.div`
  margin: 0px 0 0 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.basic2000};
`;

const Subtext = styled.h4`
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
  margin: 0 0 20px 0;
  text-align: center;
  width: 80%;

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  max-width: 400px;
`;

const Firmadigital = () => {
  const navigate = useNavigate();
  const hashFromUrl = window.location.pathname.split('/')[1];
  const hashFromLocalStorage = localStorage.getItem('hash');
  const hash = useFormStore((state) => state.hash) || hashFromLocalStorage || hashFromUrl;

  return (
    <Wrapper>
      <Lottie animationData={SignImg} style={{ width:'150px', margin:'0px' }}/> 
      <MainText>Términos y Condiciones</MainText>
      <Firma />
      <Spacer size={80} />
    </Wrapper>
  );
};

export default withAuthAndData(Firmadigital);